import { useState, useEffect, useMemo } from 'react';

import { useGetDenounceStatusForSelector } from '../../hooks/useDenounceStatusService';
import { useGetPossibleVectorFocusForSelector } from '../../hooks/usePossibleVectorFocusService';

import DataController from '../../data/DataController';

import { Button, Paper, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MonitoringFilterForm from '../Forms/MonitoringFilterForm/MonitoringFilterForm';

import './MapFilterModal.scss';

function MapFilterModal({showFilter, handleCloseFilter}) {
  const ONLY_RECENT_FOCUS = {
    "id": 0,
    "value": "Registro mais recente"
  };
  const DENOUNCE_STATUS = {
    ALL: 'Todos'
  };
  const POSSIBLE_FOCUS = {
    ALL: 'Todos'
  };
  const YEARS = {
    ALL: 'Todos'
  };
  const initialFilter = useMemo(() => ({
    csv_output: false,
    focusTypes: [],
    years: [],
    vectorStatus: [],
    focusAge: []
  }), []);
  const [refreshCount, updateRefreshCount] = useState(0);
  const [filter, setFilter] = useState(null);
  const [, denounceStatus] = useGetDenounceStatusForSelector(true);
  const [, possibleVectorFocus] = useGetPossibleVectorFocusForSelector(true);

  useEffect(() => {
    const dataController = new DataController();
    const currentFilter = dataController.getFilter();
    setFilter(currentFilter || initialFilter);
  }, [initialFilter, refreshCount]);

  function handleCloseModal() {
    updateRefreshCount(refreshCount + 1);
    handleCloseFilter();
  }

  async function handleClickUpdateFilter(values, {setSubmitting }) {
    const updatedFilter = {
      focusTypes: values.possibleFocusId === POSSIBLE_FOCUS.ALL ? [] : [
        {
          id: values.possibleFocus?.id
        }
      ],
      vectorStatus: values.denounceStatusId === DENOUNCE_STATUS.ALL ? [] : [
        {
          id: values.denounceStatus?.id
        }
      ],
      focusAge: values.onlyRecent ? [ONLY_RECENT_FOCUS] : [],
      years: values.year === YEARS.ALL ? [] : [values.year]
    };
    const dataController = new DataController();
    dataController.upsertFilter(updatedFilter);

    setSubmitting(false);
    handleCloseModal();
  }

  function handleResetForm() {
    const dataController = new DataController();
    dataController.upsertFilter(initialFilter);
    handleCloseModal();
  }

  return (
    <Modal
      open={showFilter}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="map-filters-modal">
      <Paper
        className="map-filters-modal-content"
        elevation={2}>
        {filter && (
          <MonitoringFilterForm 
            filter={filter}
            defaultDenounceStatus={DENOUNCE_STATUS}
            defaultPossibleFocus={POSSIBLE_FOCUS}
            defaultYears={YEARS}
            denounceStatus={denounceStatus}
            possibleVectorFocus={possibleVectorFocus}
            onSubmit={handleClickUpdateFilter}
            onReset={handleResetForm}
          />
        )}
        <Button
          className="close-button"
          onClick={handleCloseModal}>
          <CloseIcon/>
        </Button>
      </Paper>
    </Modal>
  );
}

export default MapFilterModal;
